module.exports = __webpack_public_path__ + "img/e_1_6_r.9d28cd4a.png";